module.exports = __webpack_public_path__ + "static/media/PDF2.b0783792.pdf";